import { render, staticRenderFns } from "./Voorblad.vue?vue&type=template&id=01a42612&scoped=true"
import script from "./Voorblad.vue?vue&type=script&lang=js"
export * from "./Voorblad.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01a42612",
  null
  
)

export default component.exports